import { cn } from "./cn.js";

/** Renders one or more keycaps for documenting a shortcut next to its action,
 *  e.g. <KeyHint keys="Space" /> or <KeyHint keys={["⌘", "Enter"]} />.
 *  Purely presentational — the actual binding lives in useHotkeys. */
type Props = {
  keys: string | string[];
  className?: string;
};

export function KeyHint({ keys, className }: Props) {
  const list = Array.isArray(keys) ? keys : [keys];
  return (
    <span className={cn("inline-flex items-center gap-0.5", className)}>
      {list.map((key, i) => (
        <kbd
          // Keycaps are a fixed, ordered label set that never reorders, so the
          // index is a stable identity here.
          // biome-ignore lint/suspicious/noArrayIndexKey: static ordered list
          key={`${key}-${i}`}
          className={cn(
            "inline-flex min-w-[18px] items-center justify-center rounded px-1 py-0.5",
            "border border-border bg-surface-elevated text-ink-muted",
            "font-mono text-[10px] font-medium leading-none",
          )}
        >
          {key}
        </kbd>
      ))}
    </span>
  );
}
